import ConversationDomain, {
  AllowedMessageType,
} from "entities/domain/conversations/conversation-domain";
import MessageDomain, {
  MessageStatus,
} from "entities/domain/conversations/message-domain";
import CustomerDomain from "entities/domain/customers/customer-domain";
import unionBy from "lodash.unionby";

export interface ConversationDomainUpdate {
  customer?: CustomerDomain;
  isOpen?: boolean;
  unreadCount?: number;
  assignedAgentId?: number;
  previewText?: string;
  displayDate?: Date;
  allowedMessageType?: AllowedMessageType;
  lastMessageStatus?: MessageStatus;
  lastMessageTitle?: string;
  messageId?: number;
}

export const updateConversation = (
  conversation: ConversationDomain,
  updates: ConversationDomainUpdate
): ConversationDomain =>
  new ConversationDomain(
    conversation.id,
    conversation.merchantId,
    updates.customer ?? conversation.customer,
    conversation.alias,
    conversation.channel,
    updates.isOpen !== undefined ? updates.isOpen : conversation.isOpen,
    conversation.createdAt,
    updates.unreadCount !== undefined
      ? updates.unreadCount
      : conversation.unreadCount,
    updates.assignedAgentId
      ? updates.assignedAgentId
      : conversation.assignedAgentId,
    updates.previewText ? updates.previewText : conversation.previewText,
    updates.lastMessageStatus
      ? updates.lastMessageStatus
      : conversation.lastMessageStatus,
    updates.displayDate ? updates.displayDate : conversation.displayDate,
    updates.messageId ? updates.messageId : conversation.messageId,
    updates.allowedMessageType
      ? updates.allowedMessageType
      : conversation.allowedMessagesType,
    updates.lastMessageTitle
      ? updates.lastMessageTitle
      : conversation.lastMessageTitle
  );

export const sortDates = (c1: Date, c2: Date): number => {
  if (c1.getTime() === c2.getTime()) {
    return 0;
  }

  if (c1.getTime() > c2.getTime()) {
    return -1;
  }

  return 1;
};

export const replaceOrAppendConversationInArray = (
  conversation: ConversationDomain,
  conversations: ConversationDomain[]
): ConversationDomain[] => {
  if (conversations.filter((c) => c.id === conversation.id).length !== 0) {
    return conversations.map((c) =>
      conversation?.id === c.id ? conversation : c
    );
  }

  return [conversation, ...conversations];
};

export const replaceOrAppendMessagesInArray = (
  newMessages: MessageDomain[],
  oldMessages: MessageDomain[]
): MessageDomain[] => {
  oldMessages.forEach((oldMessage, currentIndex) => {
    const foundIndex = newMessages.findIndex(
      (newMessage) => newMessage.id === oldMessage.id
    );

    if (foundIndex !== -1) {
      oldMessages[currentIndex] = newMessages[foundIndex];
    }

    return newMessages;
  });

  return unionBy(newMessages, oldMessages, "id");
};
